module.exports = __webpack_public_path__ + "img/Micronesia.2ac759a5.gif";